export const USER_SETTINGS_ACTIONS = {
  SILENCE_BROWSER_SECURITY_WARNING: 'USER_SETTINGS_ACTIONS/SILENCE_BROWSER_SECURITY_WARNING',
}
